import React, { useCallback, useEffect, useRef, useState } from "react";
import Player from "@vimeo/player";
import thumbnail1 from "../../../assets/images/video-carousel/png/thumb1.webp";
import thumbnail2 from "../../../assets/images/video-carousel/png/thumb2.webp";
import thumbnail3 from "../../../assets/images/video-carousel/png/thumb3.webp";
import { IndicatorsSvg } from "../../../components/WhatMakesSvg";

const VideoCarouselMobile = () => {
  const scrollContainer = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [screenSize, setScreenSize] = useState("small");
  const [isLoaded, setIsLoaded] = useState(false);
  const playerRefs = useRef([]);
  const containerRefs = useRef([]);

  const videos = [
    {
      id: "1040680999",
      title: "Unlimited Coverage for 4 Major Illnesses",
      description:
        "Unlimited Dreams, Unlimited Coverage! ManipalCigna Sarvah, a comprehensive health insurance solution that provides ultimate peace of mind with the promise of lifelong security and financial well-being. With Sarvah, get benefits like affordable essential coverage, personalized plans with unlimited coverage, zero waiting period with coverage from day 1 ensuring stress-free hospitalization. ",
      poster: thumbnail1,
    },
    {
      id: "1040665299",
      title: "Essential Coverage for 4 Major Illnesses",
      description:
        "Dream Big,  Coverage Essential! ManipalCigna Sarvah, a comprehensive health insurance solution that provides ultimate peace of mind with the promise of lifelong security and financial well-being. With Sarvah, get benefits like affordable essential coverage, personalized plans with unlimited coverage, zero waiting period with coverage from day 1 ensuring stress-free hospitalization.",
      poster: thumbnail2,
    },
    {
      id: "1040682463",
      title: "Absolutely Zero Waiting Period",
      description:
        "Zero Waiting Period, Coverage From Day1! ManipalCigna Sarvah, a comprehensive health insurance solution that provides ultimate peace of mind with the promise of lifelong security and financial well-being. With Sarvah, get benefits like affordable essential coverage, personalized plans with unlimited coverage, zero waiting period with coverage from day 1 ensuring stress-free hospitalization.",
      poster: thumbnail3,
    },
  ];

  const getCardsPerView = useCallback(() => {
    switch (screenSize) {
      case "small":
        return 1;
      case "medium":
        return 2;
      case "large":
        return 3;
      case "extraLarge":
        return 4;
      default:
        return 4;
    }
  }, [screenSize]);

  const updateScreenSize = useCallback(() => {
    const width = window.innerWidth;
    if (width < 640) setScreenSize("small");
    else if (width < 1024) setScreenSize("medium");
    else if (width < 1440) setScreenSize("large");
    else setScreenSize("extraLarge");
  }, []);

  useEffect(() => {
    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, [updateScreenSize]);

  useEffect(() => {
    if (!isLoaded) return;

    videos.forEach((video, index) => {
      if (containerRefs.current[index]) {
        const options = {
          id: video.id,
          background: false,
          muted: true,
          autoplay: false,
          loop: true,
          controls: true,
          responsive: true,
        };
        playerRefs.current[index] = new Player(
          containerRefs.current[index],
          options
        );
      }
    });

    return () => {
      playerRefs.current.forEach((player) => {
        if (player && typeof player.destroy === "function") {
          player.destroy();
        }
      });
    };
  }, [isLoaded]);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // const scroll = useCallback(
  //   (direction) => {
  //     const { current } = scrollContainer;
  //     if (current) {
  //       const cardsPerView = screenSize === "small" ? 1 : getCardsPerView();
  //       const containerWidth = current.offsetWidth;
  //       const cardWidth = containerWidth / cardsPerView;
  //       const scrollAmount = direction === "left" ? -cardWidth : cardWidth;

  //       let newScrollLeft = current.scrollLeft + scrollAmount;
  //       const maxScrollLeft = current.scrollWidth - containerWidth;

  //       if (newScrollLeft < 0) newScrollLeft = maxScrollLeft;
  //       if (newScrollLeft > maxScrollLeft) newScrollLeft = 0;

  //       current.scrollTo({
  //         left: newScrollLeft,
  //         behavior: "smooth",
  //       });

  //       const newIndex = Math.round(newScrollLeft / cardWidth);
  //       setActiveIndex(newIndex % videos.length);
  //     }
  //   },
  //   [getCardsPerView, videos.length, screenSize]
  // );

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     scroll("right");
  //   }, 5000);

  //   return () => clearInterval(interval);
  // }, [scroll]);

  const handleScroll = useCallback(() => {
    const { current } = scrollContainer;
    if (current) {
      const cardWidth = current.offsetWidth / getCardsPerView();
      const newIndex = Math.round(current.scrollLeft / cardWidth);
      setActiveIndex(newIndex % videos.length);
    }
  }, [getCardsPerView, videos.length]);

  useEffect(() => {
    const { current } = scrollContainer;
    if (current) {
      current.addEventListener("scroll", handleScroll);
      return () => current.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  const cardsPerView = getCardsPerView();
  const totalSlides = Math.ceil(videos.length / cardsPerView);

  return (
    <div className="block lg:hidden px-6 lg:px-[120px] py-20 lg:py-[120px] w-full relative">
      <h1 className="text-[40px] leading-[54px] font-semibold text-center mb-6 lg:mb-10 text-[#27506E]">
        Videos
      </h1>
      <div className="flex flex-col items-center justify-center">
        <div
          ref={scrollContainer}
          className="flex overflow-x-auto space-x-4 w-full no-scrollbar scroll-smooth"
          style={{
            scrollSnapType: "x mandatory",
            scrollBehavior: "smooth",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {videos.map((video, index) => (
            <div
              key={index}
              className="flex-shrink-0 rounded-2xl overflow-hidden"
              style={{
                width:
                  screenSize === "small"
                    ? "100%"
                    : `calc(${100 / getCardsPerView()}% - ${
                        ((getCardsPerView() - 1) * 16) / getCardsPerView()
                      }px)`,
                scrollSnapAlign: "center",
              }}
            >
              <div
                ref={(el) => (containerRefs.current[index] = el)}
                className="w-full aspect-[1.558] rounded-3xl"
              >
                {/* <div className="absolute h-full w-full bg-black rounded-3xl"></div> */}
              </div>
              <div className="py-4 px-3 flex flex-col gap-2 items-center justify-center">
                <h3 className="text-xl text-center font-medium leading-[26px]">
                  {video.title}
                </h3>
                <p className="text-black text-center text-sm leading-[22px] font-normal opacity-60">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-row items-center justify-center gap-2 mt-6">
          {[...Array(totalSlides)].map((_, i) => (
            <button
              key={i}
              onClick={() => {
                const { current } = scrollContainer;
                if (current) {
                  const cardWidth = current.offsetWidth / cardsPerView;
                  current.scrollTo({
                    left: i * cardsPerView * cardWidth,
                    behavior: "smooth",
                  });
                }
              }}
              aria-label={`Go to slide ${i + 1}`}
              aria-current={
                i === Math.floor(activeIndex / cardsPerView) ? "true" : "false"
              }
            >
              <IndicatorsSvg
                fill={
                  i === Math.floor(activeIndex / cardsPerView)
                    ? "#0B497A"
                    : "#CEDBE4"
                }
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoCarouselMobile;
